import React from 'react';

import TreeView from '@material-ui/lab/TreeView';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import CheckBox from '@material-ui/icons/DoneOutlined';
import CheckBoxOutlineBlankOutlined from '@material-ui/icons/CheckBoxOutlineBlankOutlined';
import TreeItem from '@material-ui/lab/TreeItem';
import SlideshowOutlined from '@material-ui/icons/SlideshowOutlined';

import './RequirementTree.css';

/**
 * props:
 * server
 * user
 * styles
 * statusFilter
 * userFilter
 * element
 * version
 * selection
 * onSelect
 * showTasks
 * move
 */
class RequirementTree extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
        this.styles = props.styles;
        console.log("RequirementTree:", props);
    }

    componentDidMount() {
        if(this.props.element.id) {
            this.getChildren(this.props.element);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        console.log("RequirementTree: componentDidUpdate", this.props);
        if(this.props.element.id && !prevProps.element.id) {
            this.getChildren(this.props.element);
        } else if(this.props.version !== prevProps.version) {
            this.getChildren(this.props.element);
        }
    }

    getChildren(element) {
        if(this.props.mock) {
            return;
        }

        let params = '';
        // if(this.props.user) {
        //     params += '?assigned=User/' + encodeURIComponent(this.props.user);
        //     params += '&assignedToTasksOrChildren=User/' + encodeURIComponent(this.props.user);
        // }

        // let request = `/${element.type}/${element.id}/children?collections=requirements,children,tasks`
        // FIXME Order categories: ?orderBy=accumulatedStatus:DESC,deadline,plannedStart
        let request = `/model/${element.type}/${element.id}/${this.props.metamodel.categories}/children${params}`
        this.props.globals.get(request)
            .then(res => res.json())
            .then(
                (response) => {
                    // console.log('getChildren:', response);

                    // TODO Share tasks with requirement details.
                    this.setState({
                        children: response
                    });
                },
                (error) => {
                    console.error(error);
                }
            )
    }

    render() {
        const root = this.props.element;
        const children = this.state.children;
        if(!root.id) {
            return null;
        }

        // const showAllTasks = this.props.showTasks && this.props.statusFilter === "Done/In progress/To do";
        // const showAllTasks = this.props.statusFilter === "Done/In progress";
        const showAllTasks = false;

        if(showAllTasks) {
            let expanded = [];
            this.findAllRequirementIds(this.props.element, this.state.children, expanded);

            // All nodes are expanded and cannot be modified by the user.
            return (
                <TreeView
                    key='requirementTreeExpanded'
                    expanded={expanded}
                >
                    {
                        this.renderTree(root, children)
                    }
                </TreeView>
            );
        } else {
            // The 1st level of the tree is expanded. The user can open and close nodes.
            let defaultExpanded = [root.type + '/' + root.id];

            return (
                <TreeView
                    key='requirementTreeNotExpanded'
                    defaultCollapseIcon={<ExpandMoreIcon />}
                    defaultExpandIcon={<ChevronRightIcon />}
                    defaultExpanded={defaultExpanded}
                >
                    {
                        this.renderTree(root, children)
                    }
                </TreeView>
            );
        }
    }

    findAllRequirementIds(element, children, allIds) {
        allIds.push(element.type + '/' + element.id);

        if(Array.isArray(children)) {
            children.filter(element => { return element.type !== 'Task'; })
                .map(element => this.findAllRequirementIds(element, element.children, allIds));
        }
    }

    renderTree(element, children, currentUserIsMemberOfParent) {
        const selection = this.props.selection;
        const selected = selection && element && selection.type === element.type && selection.id === element.id;
        const statusFilter = this.props.statusFilter.value;
        const onlyShowActiveCategories = this.props.statusFilter.onlyShowActiveCategories;
        const userFilter = this.props.userFilter;

        const elementStatus = element.status2 || element.status;
        const accumulatedStatus = element.accumulatedStatus;  // ProductPlanner metamodel and HappyMade metamodel

        let cssClass = undefined;
        let icon = undefined;
        // let assigned = "";

        cssClass = this.styles ? this.styles.css(element, selected) : "";
        // console.log(element.type + "/" + element.id + " cssClass:", cssClass);
        cssClass += ' ' + element.type;
        let assignedToOpenCards = 0;
        if(element.type === 'Task') {
            if(userFilter && this.filterOutTask(userFilter, element)) {
                cssClass += ' filteredOut';
            } else {
                switch (element.status) {
                    case 'To do':
                        icon = <CheckBoxOutlineBlankOutlined/>;
                        break;
                    case 'In progress':
                        icon = <SlideshowOutlined/>;
                        break;
                    case 'Done':
                        icon = <CheckBox/>;
                        break;
                    default:
                        break;
                }

                // assigned = (element.assigned && element.assigned[0] ? ' (' + element.assigned[0].name + ')' : '');
            }
        } else if(element.type === 'Requirement') {
            if (userFilter && this.filterOutRequirement(userFilter, element)) {
                // console.log("RequirementTree filtered out", element.name, "userFilter:", userFilter);
                cssClass += ' filteredOut';
            } else if (statusFilter && elementStatus) {
                if (!statusFilter.includes(elementStatus) && !statusFilter.includes(accumulatedStatus)) {
                    // console.log("RequirementTree filtered out", element.name, "elementStatus:", elementStatus, ", accumulatedStatus:", accumulatedStatus);
                    cssClass += ' filteredOut';
                    // } else if(statusFilter.includes(accumulatedStatus) && elementStatus !== accumulatedStatus) {
                    //     console.log("RequirementTree", element.name, "elementStatus:", elementStatus, "includes accumulatedStatus:", accumulatedStatus, "sumActiveTasks:", sumActiveTasks);
                    //     indicateChildren = " (...)";
                    // } else {
                    //     console.log("RequirementTree", element.name,
                    //         "elementStatus:", elementStatus,
                    //         ", accumulatedStatus:", accumulatedStatus,
                    //         ", sumActiveTasks:", sumActiveTasks,
                    //         ", cssClass:", cssClass);
                }
            }
        } else if(element.type === 'Category') {
            // console.log("RequirementTree category:", element.name, "assignedToTasks:", element.assignedToTasks);
            // Problem: New categories will not be visible.
            // if(userFilter && this.filterOutCard(userFilter, element)) {
            //     console.log("RequirementTree filtered out Category", element.name, "userFilter:", userFilter);
            //     cssClass += ' filteredOut';
            // }
            if(userFilter) {
                // TODO Count the open cards that are assigned to the user.
                // assignedToOpenTasks = this.categoryCountVisibleCards(userFilter, element);
                assignedToOpenCards = this.isAssignedTo(userFilter, element.assignedToTasks, false) ? 1 : 0;
            }

            // Problem: New categories and cards may not be visible.
            if(onlyShowActiveCategories && assignedToOpenCards === 0) {
                cssClass += ' filteredOut';
            }
        } else if(element.type === 'Card') {
            if(userFilter && this.filterOutCard(userFilter, element)) {
                // console.log("RequirementTree filtered out Card", element.name, "userFilter:", userFilter);
                cssClass += ' filteredOut';
            } else if(statusFilter && elementStatus ) {
                if(!statusFilter.includes(elementStatus) && !statusFilter.includes(accumulatedStatus)) {
                    // console.log("RequirementTree filtered out", element.name, "elementStatus:", elementStatus, ", accumulatedStatus:", accumulatedStatus);
                    cssClass += ' filteredOut';
                    // } else if(statusFilter.includes(accumulatedStatus) && elementStatus !== accumulatedStatus) {
                    //     console.log("RequirementTree", element.name, "elementStatus:", elementStatus, "includes accumulatedStatus:", accumulatedStatus, "sumActiveTasks:", sumActiveTasks);
                    //     indicateChildren = " (...)";
                    // } else {
                    //     console.log("RequirementTree", element.name,
                    //         "elementStatus:", elementStatus,
                    //         ", accumulatedStatus:", accumulatedStatus,
                    //         ", sumActiveTasks:", sumActiveTasks,
                    //         ", cssClass:", cssClass);
                }
            }
        }

        if(this.props.move) {
            if(element.type === 'Requirement' || element.type === 'Category') {
                cssClass += ' move';
            } else {
                cssClass += ' move-forbidden';
            }
        }

        let childNodes;
        if(Array.isArray(children)) {
            if(this.props.showTasks) {
                childNodes = children.filter(element => element.type === 'Task');
            } else {
                childNodes = [];
            }

            childNodes = childNodes.concat( children.filter(element => element.type !== 'Task') );
        }
        if(Array.isArray(element.cards)) {
            childNodes = childNodes.concat(element.cards);
        }

        let currentUserIsMember = currentUserIsMemberOfParent ||
            (element.members && this.props.user && element.members.map(m => m.id).indexOf(this.props.user.id) >= 0);
        let memberClass = (element.members ? (currentUserIsMember ? " is-member" : " not-member") : "");

        return (
            <TreeItem
                key={element.type + '/' + element.id}
                nodeId={element.type + '/' + element.id}
                label={
                    <div className={element.type + '-label' + memberClass}>
                        {element.name}
                        {
                            assignedToOpenCards > 0 &&
                            <span className="assignedToOpenTasks">
                                {assignedToOpenCards}
                            </span>
                        }
                    </div>
                }

                className={cssClass + (icon ? ' hasIcon' : '')}
                onLabelClick={ (event, value) => {
                    this.props.onSelect(element);
                    event.preventDefault();
                }}
            >
                {
                    childNodes && childNodes.map(element => this.renderTree(element, element.children, currentUserIsMember))
                }
            </TreeItem>
        );
    }

    filterOutTask(userFilter, element) {
        // console.log("filterOutTask", userFilter, element);
        // return !element.assigned || !element.assigned[0] || userFilter !== element.assigned[0].id;

        // let assigned = element.assigned ? element.assigned[0] : null;
        // if(assigned) {
        //     return assigned.id !== userFilter;
        // } else {
        //     return true;
        // }

        return !this.isAssignedTo(userFilter, element.assigned);
    }

    filterOutRequirement(userFilter, element) {
        // console.log("filterOutRequirement", element.name);
        return !this.isAssignedTo(userFilter, element.assignedToTasksOrChildren);
    }

    // categoryCountVisibleCards(userFilter, element) {
    //     return this.countAssignedTo(userFilter, element.assignedToTasks);
    // }

    filterOutCard(userFilter, element) {
        return !this.isAssignedTo(userFilter, element.assignedToTasks, true);
    }

    isAssignedTo(userFilter, assigned, includeUnassigned) {
        if(Array.isArray(assigned)) {
            var ret = false;
            assigned.forEach(a => {
                ret = ret || this.isAssignedTo(userFilter, a);
            });
            return ret;
        } else if(assigned) {
            let ret = assigned.type === 'User' && assigned.id === userFilter;
            return ret;
        } else {
            return includeUnassigned;
        }
    }

    // This doesn't work because we get a set of assigned, not a list.
    // countAssignedTo(userFilter, assigned, includeUnassigned) {
    //     if(Array.isArray(assigned)) {
    //         var ret = 0;
    //         assigned.forEach(a => {
    //             ret = ret + this.countAssignedTo(userFilter, a);
    //         });
    //         console.log("countAssignedTo array", assigned, ":", ret);
    //         return ret;
    //     } else if(assigned) {
    //         let check = assigned.type === 'User' && assigned.id === userFilter;
    //         console.log("countAssignedTo object", assigned, ":", ret);
    //         return check ? 1 : 0;
    //     } else {
    //         console.log("countAssignedTo null:", includeUnassigned);
    //         return includeUnassigned ? 1 : 0;
    //     }
    // }

    // TODO Copied from PlannedDates. Generalize.
    /** Format a date to format 2020-01-31 */
    dateToString(date) {
        if(date instanceof Date) {
            return date.toISOString().split('T')[0]
        } else if(typeof date === 'string') {
            return date.split('T')[0]
        } else if(!date) {
            return date;
        } else {
            console.error("Cannot convert", date, "with type", date.constructor.name, "to date");
            return date;
        }
    }
}

export default RequirementTree;